import AppConfig from 'Constants/AppConfig';
import { getImageFileFromUrl } from './helpers/commonHelper';
import { i18n } from '@/lang/';

export const bizgainOnboardingRoutes = Object.freeze({
  bizgain: {
    name: 'bizgain',
    path: 'signup'
  },
  BusinessDetailsSetupAnimation: {
    name: 'businessDetailsSetupAnimation',
    path: 'businessDetailsSetupAnimation'
  },
  RouteConfirmation: {
    name: 'confirmation',
    path: 'confirmation'
  },
  SetupBusinessInfo: {
    name: 'setupBusinessInfo',
    path: 'setupBusinessInfo',
    helpText: i18n.tc('message.bizgainOnboarding.extractBusinessDetailsHelpText'),
    animationPath: 'assets/animation/Businessdetails/BusinessdetailsSlowJson.json'
  },
  ExtractBusinessDetails: {
    name: 'businessDetails',
    path: 'businessDetails',
    helpText: i18n.tc('message.bizgainOnboarding.extractBusinessDetailsHelpText'),
    animationPath: 'assets/animation/Businessdetails/BusinessdetailsSlowJson.json'
  },
  ExtractOfferDetails: {
    name: 'offerDetails',
    path: 'offerDetails',
    helpText: i18n.tc('message.bizgainOnboarding.extractOfferDetailsHelpText'),
    animationPath: 'assets/animation/Creative/CreativeJson.json'
  },
  BusinessTypeServices: {
    name: 'businessTypeServices',
    path: 'businessTypeServices',
    helpText: i18n.tc('message.bizgainOnboarding.businessTypeServicesHelpText'),
    animationPath: 'assets/animation/Businessdetails/BusinessdetailsSlowJson.json'
  },
  SelectGender: {
    name: 'selectGender',
    path: 'selectGender',
    helpText: i18n.tc('message.bizgainOnboarding.selectGenderHelpText'),
    animationPath: 'assets/animation/Businessdetails/BusinessdetailsSlowJson.json'
  },
  SelectObjective: {
    name: 'selectObjective',
    path: 'selectObjective',
    helpText: i18n.tc('message.bizgainOnboarding.selectObjectiveHelpText'),
    animationPath: 'assets/animation/Businessdetails/BusinessdetailsSlowJson.json'
  },
  LeadAdsPreview: {
    name: 'leadAdsPreview',
    path: 'leadAdsPreview',
    helpText: i18n.tc('message.bizgainOnboarding.leadAdsDisplayPreviewAnimationText'),
    animationPath: 'assets/animation/Creative/CreativeJson.json'
  },
  LeadAdsEdit: {
    name: 'leadAdsEdit',
    path: 'leadAdsEdit',
    helpText: i18n.tc('message.bizgainOnboarding.leadAdsEditAnimationText'),
    animationPath: 'assets/animation/Creative/CreativeJson.json'
  },
  PrivacyPolicyPermissions: {
    name: 'privacyPolicyPermissions',
    path: 'privacyPolicyPermissions',
    helpText: i18n.tc('message.bizgainOnboarding.privacyPolicyDataPermissionsAnimationText'),
    animationPath: 'assets/animation/Creative/CreativeJson.json'
  },
  PrivacyPolicyPreview: {
    name: 'privacyPolicyPreview',
    path: 'privacyPolicyPreview',
    helpText: i18n.tc('message.bizgainOnboarding.privacyPolicyPreviewAnimationText'),
    animationPath: 'assets/animation/Creative/CreativeJson.json'
  },
  ImageCreatives: {
    name: 'imageCreatives',
    path: 'imageCreatives',
    helpText: i18n.tc('message.bizgainOnboarding.creativesHelpText'),
    animationPath: 'assets/animation/Creative/CreativeJson.json'
  },
  ImageCreativesCreativePreview: {
    name: 'imageCreativesCreativePreview',
    path: 'imageCreativesCreative/preview/:id',
    helpText: i18n.tc('message.bizgainOnboarding.creativesCreativePreviewHelpText'),
    animationPath: 'assets/animation/Creative/CreativeJson.json'
  },
  ImageCreativesCreativeEdit: {
    name: 'imageCreativesCreativeEdit',
    path: 'imageCreativesCreative/edit/:id',
    helpText: i18n.tc('message.bizgainOnboarding.creativesCreativePreviewHelpText'),
    animationPath: 'assets/animation/Creative/CreativeJson.json'
  },
  ImageCreativesAdPreview: {
    name: 'imageCreativesAdPreview',
    path: 'ImageCreativesAdPreview/preview/:id',
    helpText: i18n.tc('message.bizgainOnboarding.creativesPreviewHelpText'),
    animationPath: 'assets/animation/Creative/CreativeJson.json'
  },
  ImageCreativesAdDetailsEdit: {
    name: 'imageCreativesAdDetailsEdit',
    path: 'imageCreativesAdDetailsEdit/edit/:id',
    helpText: i18n.tc('message.bizgainOnboarding.adDetailsEditHelpText'),
    animationPath: 'assets/animation/Creative/CreativeJson.json'
  },
  GoogleAds: {
    name: 'googleAds',
    path: 'googleAds',
    helpText: i18n.tc('message.bizgainOnboarding.googleAdsHelpText'),
    animationPath: 'assets/animation/Creative/CreativeJson.json'
  },
  GoogleAdsEdit: {
    name: 'googleAdsEdit',
    path: 'googleAdsEdit',
    helpText: i18n.tc('message.bizgainOnboarding.googleAdsEditHelpText'),
    animationPath: 'assets/animation/Creative/CreativeJson.json'
  },
  BusinessLocationDetails: {
    name: 'businessLocationDetails',
    path: 'businessLocationDetails',
    helpText: i18n.tc('message.bizgainOnboarding.businessLocationDetailsHelpText'),
    animationPath: 'assets/animation/Businessdetails/BusinessdetailsSlowJson.json'
  },
  EmailSignup: {
    name: 'emailSignup',
    path: 'emailSignup',
    helpText: i18n.tc('message.bizgainOnboarding.emailSignupHelpText'),
    animationPath: 'assets/animation/Creative/CreativeJson.json'
  },
  PromoteServices: {
    name: 'promoteServices',
    path: 'promoteServices',
    helpText: i18n.tc('message.bizgainOnboarding.promoteServicesHelpText'),
    animationPath: 'assets/animation/Creative/CreativeJson.json'
  },
  AgeGenderTarget: {
    name: 'ageGenderTarget',
    path: 'ageGenderTarget',
    helpText: i18n.tc('message.bizgainOnboarding.ageGenderTargetHelpText'),
    animationPath: 'assets/animation/Targeting/TargetingJson.json'
  },
  LocationTargeting: {
    name: 'locationTargeting',
    path: 'locationTargeting',
    helpText: i18n.tc('message.bizgainOnboarding.locationTargetingHelpText'),
    animationPath: 'assets/animation/Targeting/TargetingJson.json'
  },
  Budget: {
    name: 'budget',
    path: 'budget',
    helpText: i18n.tc('message.bizgainOnboarding.budgetHelpText'),
    animationPath: 'assets/animation/Launching/LaunchingJson.json'
  },
  LinkAccounts: {
    name: 'linkAccounts',
    path: 'linkAccounts',
    helpText: i18n.tc('message.bizgainOnboarding.accountDetailsHelpText'),
    animationPath: 'assets/animation/Launching/LaunchingJson.json'
  },
  LaunchAnimation: {
    name: 'launching',
    path: 'launching',
    animationPath: 'assets/animation/Phase3Completion/Phase3Completion.json'
  },
  CreativeAnimation: {
    name: 'creative',
    path: 'creative',
    animationPath: 'assets/animation/Phase2Completion/Phase2Completion.json'
  },
  BusinessDetailsAnimation: {
    name: 'businessDetailsCaptured',
    path: 'businessDetailsCaptured',
    animationPath: 'assets/animation/Phase1Completion/Phase1Completion.json'
  },
  AdAccountSetupAnimation: {
    name: 'adAccountSetup',
    path: 'adAccountSetup',
    helpText: i18n.tc('message.bizgainOnboarding.budgetHelpText'),
    animationPath: 'assets/animation/Analyze/Analyze.json'
  },
  campaign: {
    name: 'campaign',
    path: '/app/:businessProfileId/campaign/:campaignId'
  },
  SubsequentSelectObjective: {
    name: 'subSequentSelectObjective',
    path: 'selectObjective',
    helpText: i18n.tc('message.bizgainOnboarding.selectObjectiveHelpText'),
    animationPath: 'assets/animation/Businessdetails/BusinessdetailsSlowJson.json'
  },
  SubsequentPromoteServices: {
    name: 'subSequentPromoteServices',
    path: 'promoteServices',
    helpText: i18n.tc('message.bizgainOnboarding.promoteServicesHelpText'),
    animationPath: 'assets/animation/Creative/CreativeJson.json'
  },
  SubsequentExtractOfferDetails: {
    name: 'subSequentOfferDetails',
    path: 'offerDetails',
    helpText: i18n.tc('message.bizgainOnboarding.extractOfferDetailsHelpText'),
    animationPath: 'assets/animation/Creative/CreativeJson.json'
  },
  SubsequentImageCreatives: {
    name: 'subSequentImageCreatives',
    path: 'imageCreatives',
    helpText: i18n.tc('message.bizgainOnboarding.creativesHelpText'),
    animationPath: 'assets/animation/Creative/CreativeJson.json'
  },
  SubsequentImageCreativesCreativePreview: {
    name: 'subSequentImageCreativesCreativePreview',
    path: 'imageCreativesCreative/preview/:id',
    helpText: i18n.tc('message.bizgainOnboarding.creativesCreativePreviewHelpText'),
    animationPath: 'assets/animation/Creative/CreativeJson.json'
  },
  SubsequentImageCreativesCreativeEdit: {
    name: 'subSequentImageCreativesCreativeEdit',
    path: 'imageCreativesCreative/edit/:id',
    helpText: i18n.tc('message.bizgainOnboarding.creativesCreativePreviewHelpText'),
    animationPath: 'assets/animation/Creative/CreativeJson.json'
  },
  SubsequentImageCreativesAdPreview: {
    name: 'subSequentImageCreativesAdPreview',
    path: 'ImageCreativesAdPreview/preview/:id',
    helpText: i18n.tc('message.bizgainOnboarding.creativesPreviewHelpText'),
    animationPath: 'assets/animation/Creative/CreativeJson.json'
  },
  SubsequentImageCreativesAdDetailsEdit: {
    name: 'subSequentImageCreativesAdDetailsEdit',
    path: 'imageCreativesAdDetailsEdit/edit/:id',
    helpText: i18n.tc('message.bizgainOnboarding.adDetailsEditHelpText'),
    animationPath: 'assets/animation/Creative/CreativeJson.json'
  },
  SubsequentGoogleAds: {
    name: 'subSequentgoogleAds',
    path: 'googleAds',
    helpText: i18n.tc('message.bizgainOnboarding.googleAdsHelpText'),
    animationPath: 'assets/animation/Creative/CreativeJson.json'
  },
  SubsequentGoogleAdsEdit: {
    name: 'subSequentgoogleAdsEdit',
    path: 'googleAdsEdit',
    helpText: i18n.tc('message.bizgainOnboarding.googleAdsEditHelpText'),
    animationPath: 'assets/animation/Creative/CreativeJson.json'
  },
  SubsequentAgeGenderTarget: {
    name: 'subSequentAgeGenderTarget',
    path: 'ageGenderTarget',
    helpText: i18n.tc('message.bizgainOnboarding.ageGenderTargetHelpText'),
    animationPath: 'assets/animation/Targeting/TargetingJson.json'
  },
  SubsequentLocationTargeting: {
    name: 'subSequentLocationTargeting',
    path: 'locationTargeting',
    helpText: i18n.tc('message.bizgainOnboarding.locationTargetingHelpText'),
    animationPath: 'assets/animation/Targeting/TargetingJson.json'
  },
  BusinessPhoneNumber: {
    name: 'businessPhoneNumber',
    path: 'businessPhoneNumber',
    helpText: i18n.tc('message.bizgainOnboarding.businessPhoneNumberHelpText'),
    animationPath: 'assets/animation/Businessdetails/BusinessdetailsSlowJson.json'
  },
  SubsequentCreativeAnimation: {
    name: 'subsequentCreative',
    path: 'creative',
    animationPath: 'assets/animation/Phase2Completion/Phase2Completion.json'
  },
  SubsequentBudget: {
    name: 'subsequentBudget',
    path: 'budget',
    helpText: i18n.tc('message.bizgainOnboarding.budgetHelpText'),
    animationPath: 'assets/animation/Launching/LaunchingJson.json'
  },
  Summary: {
    name: 'summary',
    path: 'summary',
    animationPath: 'assets/animation/Creative/CreativeJson.json'
  },
  SummaryLink: {
    name: 'summaryLink',
    path: 's/:encodedId',
    animationPath: 'assets/animation/Creative/CreativeJson.json'
  },
  //added route for shorten flow
  BusinessDetailsV2: {
    name: 'businessDetailsv2',
    path: 'businessDetailsv2',
    helpText: i18n.tc('message.bizgainOnboarding.extractBusinessDetailsHelpText'),
    animationPath: 'assets/animation/Businessdetails/BusinessdetailsSlowJson.json'
  },
  BusinessDetailsSetupAnimationV2: {
    name: 'businessDetailsSetupAnimationV2',
    path: 'businessDetailsSetupAnimationV2',
    helpText: i18n.tc('message.bizgainOnboarding.extractBusinessDetailsHelpText'),
    animationPath: 'assets/animation/Businessdetails/BusinessdetailsSlowJson.json'
  },
  CreativeDetailsV2: {
    name: 'creativedetailsv2',
    path: 'creativedetailsv2/preview/:id',
    helpText: i18n.tc('message.bizgainOnboarding.creativesPreviewHelpText'),
    animationPath: 'assets/animation/Creative/CreativeJson.json'
  },
  TargetingV2: {
    name: 'targetingv2',
    path: 'targetingv2',
    helpText: i18n.tc('message.bizgainOnboarding.locationTargetingHelpText'),
    animationPath: 'assets/animation/Targeting/TargetingJson.json'
  },
  SubsequentBusinessDetailsV2: {
    name: 'subsequentbusinessDetailsv2',
    path: 'subsequentbusinessDetailsv2',
    helpText: i18n.tc('message.bizgainOnboarding.extractBusinessDetailsHelpText'),
    animationPath: 'assets/animation/Businessdetails/BusinessdetailsSlowJson.json'
  },
  SubsequentBusinessDetailsSetupAnimationV2: {
    name: 'subsequentbusinessDetailsSetupAnimationV2',
    path: 'subsequentbusinessDetailsSetupAnimationV2',
    helpText: i18n.tc('message.bizgainOnboarding.extractBusinessDetailsHelpText'),
    animationPath: 'assets/animation/Businessdetails/BusinessdetailsSlowJson.json'
  },
  SubsequentCreativeDetailsV2: {
    name: 'subsequentcreativedetailsv2',
    path: 'subsequentcreativedetailsv2/preview/:id',
    helpText: i18n.tc('message.bizgainOnboarding.creativesPreviewHelpText'),
    animationPath: 'assets/animation/Creative/CreativeJson.json'
  },
  SubsequentTargetingV2: {
    name: 'subsequenttargetingv2',
    path: 'subsequenttargetingv2',
    helpText: i18n.tc('message.bizgainOnboarding.locationTargetingHelpText'),
    animationPath: 'assets/animation/Targeting/TargetingJson.json'
  },
  FacebookInterests: {
    name: 'facebookInterests',
    path: 'fbInterests',
    animationPath: 'assets/animation/Targeting/TargetingJson.json'
  },
  GoogleKeywords: {
    name: 'googleKeywords',
    path: 'googleKeywords',
    animationPath: 'assets/animation/Targeting/TargetingJson.json'
  },
  SubsequentGoogleKeywords: {
    name: 'subsequentGoogleKeywords',
    path: 'googleKeywords',
    animationPath: 'assets/animation/Targeting/TargetingJson.json'
  },
  ChannelSelection: {
    name: 'channelSelection',
    path: '/app/:businessProfileId/campaign/:campaignId/channelSelection',
    animationPath: 'assets/animation/Targeting/TargetingJson.json'
  }
})

export const bizgainOnboardingRedirects = Object.freeze({
  businessDetails: {
    default: bizgainOnboardingRoutes.BusinessLocationDetails.name
  },
  businessDetailsSetupAnimation: {
    default: bizgainOnboardingRoutes.BusinessLocationDetails.name
  },
  businessLocationDetails: {
    default: bizgainOnboardingRoutes.BusinessPhoneNumber.name,
    agentFlow: bizgainOnboardingRoutes.SelectObjective.name,
    agentFlowLaunchState: 500 //launchState.BUSINESSTYPESERVICES
  },
  businessPhoneNumber: {
    default: bizgainOnboardingRoutes.BusinessDetailsAnimation.name,
    shortenFlow: bizgainOnboardingRoutes.Budget.name,
    autoGeneratedFlow: bizgainOnboardingRoutes.SetupBusinessInfo.name
  },
  businessTypeServices: {
    default: bizgainOnboardingRoutes.BusinessDetailsAnimation.name
  },
  businessDetailsCaptured: {
    default: bizgainOnboardingRoutes.SelectObjective.name
  },
  selectObjective: {
    default: bizgainOnboardingRoutes.ExtractOfferDetails.name
  },
  subSequentSelectObjective: {
    default: bizgainOnboardingRoutes.SubsequentExtractOfferDetails.name
  },
  promoteServices: {
    default: bizgainOnboardingRoutes.ExtractOfferDetails.name
  },
  subSequentPromoteServices: {
    default: bizgainOnboardingRoutes.SubsequentExtractOfferDetails.name
  },
  offerDetails: {
    default: bizgainOnboardingRoutes.ImageCreatives.name
  },
  subSequentOfferDetails: {
    default: bizgainOnboardingRoutes.SubsequentImageCreatives.name
  },
  imageCreatives: {
    default: bizgainOnboardingRoutes.ImageCreativesCreativePreview.name
  },
  subSequentImageCreatives: {
    default: bizgainOnboardingRoutes.SubsequentImageCreativesCreativePreview.name
  },
  imageCreativesCreativePreview: {
    default: bizgainOnboardingRoutes.ImageCreativesAdPreview.name,
    edit: bizgainOnboardingRoutes.ImageCreativesCreativeEdit.name
  },
  subSequentImageCreativesCreativePreview: {
    default: bizgainOnboardingRoutes.SubsequentImageCreativesAdPreview.name,
    edit: bizgainOnboardingRoutes.SubsequentImageCreativesCreativeEdit.name
  },
  imageCreativesCreativeEdit: {
    default: bizgainOnboardingRoutes.ImageCreativesCreativePreview.name,
    shortenFlow: bizgainOnboardingRoutes.CreativeDetailsV2.name,
    autoGeneratedFlow: bizgainOnboardingRoutes.SetupBusinessInfo.name
  },
  subSequentImageCreativesCreativeEdit: {
    default: bizgainOnboardingRoutes.SubsequentImageCreativesCreativePreview.name,
    shortenFlow: bizgainOnboardingRoutes.SubsequentCreativeDetailsV2.name
  },
  imageCreativesAdPreview: {
    default: bizgainOnboardingRoutes.GoogleAds.name,
    defaultNext: bizgainOnboardingRoutes.EmailSignup.name,
    defaultNextLaunchState: 1500, //launchState.SIGNUP
    agentFlowNext: bizgainOnboardingRoutes.AgeGenderTarget.name,
    PhoneNoRequiredFlow: bizgainOnboardingRoutes.CreativeAnimation.name,
    PhoneNoRequiredFlowLaunchState: 1501, //launchState.CREATIVE
    agentFlowNextLaunchState: 1600, //launchState.AGEGENDERTARGETING
    edit: bizgainOnboardingRoutes.ImageCreativesAdDetailsEdit.name
  },
  subSequentImageCreativesAdPreview: {
    default: bizgainOnboardingRoutes.SubsequentGoogleAds.name,
    defaultNext: bizgainOnboardingRoutes.SubsequentCreativeAnimation.name,
    defaultNextLaunchState: 1501, //launchState.CREATIVEANIMATION
    edit: bizgainOnboardingRoutes.SubsequentImageCreativesAdDetailsEdit.name
  },
  imageCreativesAdDetailsEdit: {
    default: bizgainOnboardingRoutes.ImageCreativesAdPreview.name,
    shortenFlow: bizgainOnboardingRoutes.CreativeDetailsV2.name,
    autoGeneratedFlow: bizgainOnboardingRoutes.SetupBusinessInfo.name
  },
  subSequentImageCreativesAdDetailsEdit: {
    default: bizgainOnboardingRoutes.SubsequentImageCreativesAdPreview.name,
    shortenFlow: bizgainOnboardingRoutes.SubsequentCreativeDetailsV2.name
  },
  googleAds: {
    default: bizgainOnboardingRoutes.EmailSignup.name,
    agentFlow: bizgainOnboardingRoutes.AgeGenderTarget.name,
    PhoneNoRequiredFlow: bizgainOnboardingRoutes.CreativeAnimation.name,
    agnetFlowLaunchState: 1600, //launchState.AGEGENDERTARGETING
    edit: bizgainOnboardingRoutes.GoogleAdsEdit.name
  },
  subSequentgoogleAds: {
    default: bizgainOnboardingRoutes.SubsequentCreativeAnimation.name,
    edit: bizgainOnboardingRoutes.SubsequentGoogleAdsEdit.name
  },
  googleAdsEdit: {
    default: bizgainOnboardingRoutes.GoogleAds.name,
    shortenFlow: bizgainOnboardingRoutes.CreativeDetailsV2.name,
    autoGeneratedFlow: bizgainOnboardingRoutes.SetupBusinessInfo.name
  },
  subSequentgoogleAdsEdit: {
    default: bizgainOnboardingRoutes.SubsequentGoogleAds.name,
    shortenFlow: bizgainOnboardingRoutes.SubsequentCreativeDetailsV2.name
  },
  emailSignup: {
    default: bizgainOnboardingRoutes.CreativeAnimation.name,
    shortenFlow: bizgainOnboardingRoutes.Budget.name,
    autoGeneratedFlow: bizgainOnboardingRoutes.SetupBusinessInfo.name
    //agentFlow: bizgainOnboardingRoutes.AgeGenderTarget.name,
    //agentFlowLaunchState: 1600 //launchState.AGEGENDERTARGETING
  },
  creative: {
    default: bizgainOnboardingRoutes.AgeGenderTarget.name,
    agentFlow: bizgainOnboardingRoutes.Budget.name,
    agentFlowLaunchState: 1800 //launchState.BUDGET
  },
  subsequentCreative: {
    default: bizgainOnboardingRoutes.SubsequentAgeGenderTarget.name
  },
  ageGenderTarget: {
    default: bizgainOnboardingRoutes.LocationTargeting.name
  },
  subSequentAgeGenderTarget: {
    default: bizgainOnboardingRoutes.SubsequentLocationTargeting.name
  },
  locationTargeting: {
    default: bizgainOnboardingRoutes.Budget.name,
    agentFlow: bizgainOnboardingRoutes.Summary.name
  },
  subSequentLocationTargeting: {
    default: bizgainOnboardingRoutes.SubsequentBudget.name
  },
  summary: {
    default: bizgainOnboardingRoutes.EmailSignup.name,
    agentFlow: bizgainOnboardingRoutes.Budget.name
  },
  budget: {
    default: bizgainOnboardingRoutes.ChannelSelection.name
  },
  subsequentBudget: {
    default: bizgainOnboardingRoutes.ChannelSelection.name,
    linkedFacebookPage: bizgainOnboardingRoutes.LaunchAnimation.name
  },
  channelSelection: {
    default: bizgainOnboardingRoutes.FacebookInterests.name,
    shortenFlow: bizgainOnboardingRoutes.TargetingV2.name
  },
  adAccountSetup: {
    default: bizgainOnboardingRoutes.LinkAccounts.name
  },

  //redirecting logic for shorten flow

  businessDetailsv2: {
    default: bizgainOnboardingRoutes.BusinessDetailsSetupAnimationV2.name
  },
  businessDetailsSetupAnimationV2: {
    default: bizgainOnboardingRoutes.CreativeDetailsV2.name
  },
  creativedetailsv2: {
    default: bizgainOnboardingRoutes.EmailSignup.name,
    PhoneNoRequired: bizgainOnboardingRoutes.BusinessPhoneNumber.name,
    PhoneNoOptional: bizgainOnboardingRoutes.BusinessPhoneNumber.name,
    authSkip: bizgainOnboardingRoutes.Budget.name,
    imageCreativesCreativeEdit: bizgainOnboardingRoutes.ImageCreativesCreativeEdit.name,
    imageCreativesAdDetailsEdit: bizgainOnboardingRoutes.ImageCreativesAdDetailsEdit.name,
    googleAdsEdit: bizgainOnboardingRoutes.GoogleAdsEdit.name
  },
  subsequentbusinessDetailsv2: {
    default: bizgainOnboardingRoutes.SubsequentBusinessDetailsSetupAnimationV2.name
  },
  subsequentbusinessDetailsSetupAnimationV2: {
    default: bizgainOnboardingRoutes.SubsequentCreativeDetailsV2.name
  },
  subsequentcreativedetailsv2: {
    default: bizgainOnboardingRoutes.SubsequentBudget.name,
    imageCreativesCreativeEdit: bizgainOnboardingRoutes.SubsequentImageCreativesCreativeEdit.name,
    imageCreativesAdDetailsEdit: bizgainOnboardingRoutes.SubsequentImageCreativesAdDetailsEdit.name,
    googleAdsEdit: bizgainOnboardingRoutes.SubsequentGoogleAdsEdit.name
  },
  targeting: {
    default: bizgainOnboardingRoutes.FacebookInterests.name
  },
  adAccountSetupAnimation: {
    default: bizgainOnboardingRoutes.LinkAccounts.name
  },
  linkAccounts: {
    default: bizgainOnboardingRoutes.LaunchAnimation.name
  },

  // redirect auto gen flow

  setupBusinessInfo: {
    default: bizgainOnboardingRoutes.EmailSignup.name,
    PhoneNoRequired: bizgainOnboardingRoutes.BusinessPhoneNumber.name,
    PhoneNoOptional: bizgainOnboardingRoutes.BusinessPhoneNumber.name,
    authSkip: bizgainOnboardingRoutes.Budget.name,
    imageCreativesCreativeEdit: bizgainOnboardingRoutes.ImageCreativesCreativeEdit.name,
    imageCreativesAdDetailsEdit: bizgainOnboardingRoutes.ImageCreativesAdDetailsEdit.name,
    googleAdsEdit: bizgainOnboardingRoutes.GoogleAdsEdit.name
  }
})

export const animationPaths = Object.freeze({
  tickAnimation: 'assets/animation/Done/Done Json.json'
});

export const weekDays = Object.freeze([
  {
    id: 0,
    name: i18n.tc('message.bizgainOnboarding.weekDaySunday'),
    shortName: 'Sun'
  },
  {
    id: 1,
    name: i18n.tc('message.bizgainOnboarding.weekDayMonday'),
    shortName: 'Mon'
  },
  {
    id: 2,
    name: i18n.tc('message.bizgainOnboarding.weekDayTuesday'),
    shortName: 'Tue'
  },
  {
    id: 3,
    name: i18n.tc('message.bizgainOnboarding.weekDayWednesday'),
    shortName: 'Wed'
  },
  {
    id: 4,
    name: i18n.tc('message.bizgainOnboarding.weekDayThursday'),
    shortName: 'Thu'
  },
  {
    id: 5,
    name: i18n.tc('message.bizgainOnboarding.weekDayFriday'),
    shortName: 'Fri'
  }, {
    id: 6,
    name: i18n.tc('message.bizgainOnboarding.weekDaySaturday'),
    shortName: 'Sat'
  }]);

export const offerTypes = Object.freeze([
  {
    text: i18n.tc('message.bizgainOnboarding.percentageOffer'),
    value: 1
  },
  {
    text: i18n.tc('message.bizgainOnboarding.flatOffer'),
    value: 2
  },
  {
    text: i18n.tc('message.bizgainOnboarding.freeService'),
    value: 3
  },
  {
    text: i18n.tc('message.bizgainOnboarding.custom'),
    value: 5
  }
]);

export const bizgainOnboardingImage = Object.freeze({
  businessDetails: `${AppConfig.staticImagesBasePath}bizgainOnboarding/profile-verification.png`,
  bothGender: `${AppConfig.staticImagesBasePath}bizgainOnboarding/both.png`,
  maleGender: `${AppConfig.staticImagesBasePath}bizgainOnboarding/male.png`,
  femaleGender: `${AppConfig.staticImagesBasePath}bizgainOnboarding/female.png`,
  lead: `${AppConfig.staticImagesBasePath}bizgainOnboarding/objectives/lead.png`,
  phoneCall: `${AppConfig.staticImagesBasePath}bizgainOnboarding/objectives/phone-call.png`,
  storeVisit: `${AppConfig.staticImagesBasePath}bizgainOnboarding/objectives/store-visit.png`,
  websiteVisit: `${AppConfig.staticImagesBasePath}bizgainOnboarding/objectives/website-visit.png`,
  instantMessage: `${AppConfig.staticImagesBasePath}bizgainOnboarding/objectives/instant-messages.png`,
  globe: `${AppConfig.staticImagesBasePath}bizgainOnboarding/globe.png`,
  confirmation: `${AppConfig.staticImagesBasePath}bizgainOnboarding/bizgain-confirmation.png`,
  campaignReview: `${AppConfig.staticImagesBasePath}bizgainOnboarding/bizgain-review.png`,
  fb: `${AppConfig.staticImagesBasePath}bizgainOnboarding/payment-pop-up/fb.png`,
  google: `${AppConfig.staticImagesBasePath}bizgainOnboarding/payment-pop-up/google.png`,
  ig: `${AppConfig.staticImagesBasePath}bizgainOnboarding/payment-pop-up/ig.png`,
  withOffer: `${AppConfig.staticImagesBasePath}bizgainOnboarding/offer/withOffer.svg`,
  withoutOffer: `${AppConfig.staticImagesBasePath}bizgainOnboarding/offer/withoutOffer.png`,
  like: `${AppConfig.staticImagesBasePath}bizgainOnboarding/adPreview/heart.png`,
  comment: `${AppConfig.staticImagesBasePath}bizgainOnboarding/adPreview/chat.png`,
  share: `${AppConfig.staticImagesBasePath}bizgainOnboarding/adPreview/paper-plane.png`,
  bookmark: `${AppConfig.staticImagesBasePath}bizgainOnboarding/adPreview/save-instagram.png`,
  facebookLogo: `${AppConfig.staticImagesBasePath}bizgainOnboarding/adPreview/facebook-logo.png`,
  instagramLogo: `${AppConfig.staticImagesBasePath}bizgainOnboarding/adPreview/instagram-logo.png`,
  leftArrow: `${AppConfig.staticImagesBasePath}bizgainOnboarding/adPreview/left-arrow.png`,
  rightArrow: `${AppConfig.staticImagesBasePath}bizgainOnboarding/adPreview/right-arrow.png`,
  noInstagramProfile: `${AppConfig.staticImagesBasePath}bizgainOnboarding/linkAccounts/no-instagram-profile.png`,
  none: `${AppConfig.staticImagesBasePath}bizgainOnboarding/linkAccounts/none.png`,
  budgetSelectedIcon: `${AppConfig.staticImagesBasePath}bizgainOnboarding/budget/budget-pack-selected.png`,
  budgetNotSelectedIcon: `${AppConfig.staticImagesBasePath}bizgainOnboarding/budget/budget-pack-not-selected.png`,
  offerIcon: `${AppConfig.staticImagesBasePath}bizgainOnboarding/budget/offer-icon.png`,
  gmail: `${AppConfig.staticImagesBasePath}bizgainOnboarding/share-summary-apps-icons/icons8-gmail-logo.svg`,
  whatsapp: `${AppConfig.staticImagesBasePath}bizgainOnboarding/share-summary-apps-icons/whatsApp.svg`,
  sms: `${AppConfig.staticImagesBasePath}bizgainOnboarding/share-summary-apps-icons/sms.svg`,
  changeIcon: `${AppConfig.staticImagesBasePath}bizgainOnboarding/share-summary-apps-icons/change.svg`,
  resumeIcon: `${AppConfig.staticImagesBasePath}bizgainOnboarding/share-summary-apps-icons/resume.svg`,
  resumeActiveIcon: `${AppConfig.staticImagesBasePath}bizgainOnboarding/share-summary-apps-icons/resume-active.svg`,
  restartIcon: `${AppConfig.staticImagesBasePath}bizgainOnboarding/share-summary-apps-icons/restart.svg`,
  creativeIcon: `${AppConfig.staticImagesBasePath}bizgainOnboarding/adPreview/creative-icon.png`,
  editIcon: `${AppConfig.staticImagesBasePath}bizgainOnboarding/adPreview/edit-icon.png`,
  suggestionIcon: `${AppConfig.staticImagesBasePath}bizgainOnboarding/suggestion_icon.png`,
  previewUnavailable: `${AppConfig.staticImagesBasePath}bizgainOnboarding/preivew-unavailable.jpg`
});

export const googleMapUrl = 'https://maps.googleapis.com/maps/api/js?libraries=places&key=';

export const campaignType = Object.freeze({
  Draftcampaign: 1,
  Mediaplan: 2
});

export const offerType = Object.freeze({
  percentageOffer: 1,
  flatOffer: 2,
  freeService: 3,
  custom: 5,
  skip: 6
});

export const offerCardType = Object.freeze({
  withOffer: {
    id: 1,
    title: 'message.bizgainOnboarding.withOffer',
    imageUrl: bizgainOnboardingImage.withOffer
  },
  withoutOffer: {
    id: 2,
    title: 'message.bizgainOnboarding.withoutOffer',
    imageUrl: bizgainOnboardingImage.withoutOffer
  }
});

export const genderTypes = Object.freeze({
  all:
  {
    id: 3,
    title: 'message.bizgainOnboarding.both',
    shortTitle: 'message.bizgainOnboarding.all',
    imageUrl: bizgainOnboardingImage.bothGender,
    content: 'message.bizgainOnboarding.genderAllHint'
  },
  male:
  {
    id: 1,
    title: 'message.bizgainOnboarding.onlyMen',
    shortTitle: 'message.bizgainOnboarding.male',
    imageUrl: bizgainOnboardingImage.maleGender,
    content: 'message.bizgainOnboarding.genderMaleHint'
  },
  female:
  {
    id: 2,
    title: 'message.bizgainOnboarding.onlyWomen',
    shortTitle: 'message.bizgainOnboarding.female',
    imageUrl: bizgainOnboardingImage.femaleGender,
    content: 'message.bizgainOnboarding.genderFemaleHint'
  }
})

export const objectiveType = Object.freeze({
  calls:
  {
    id: 1,
    title: 'message.bizgainOnboarding.phoneCalls',
    conversionTitle: 'message.bizgainOnboarding.conversionCalls',
    imageUrl: bizgainOnboardingImage.phoneCall
  },
  leadGeneration:
  {
    id: 2,
    title: 'message.bizgainOnboarding.leads',
    conversionTitle: 'message.bizgainOnboarding.conversionLeads',
    imageUrl: bizgainOnboardingImage.lead
  },
  websiteVisits:
  {
    id: 3,
    title: 'message.bizgainOnboarding.websiteVisit',
    conversionTitle: 'message.bizgainOnboarding.conversionWebsiteVisits',
    imageUrl: bizgainOnboardingImage.websiteVisit
  },
  instantMessages:
  {
    id: 5,
    title: 'message.bizgainOnboarding.instantMessages',
    conversionTitle: 'message.bizgainOnboarding.conversionInstantMessages',
    imageUrl: bizgainOnboardingImage.instantMessage
  }
  // storeVisits:
  // {
  //   id: 4,
  //   title: 'message.bizgainOnboarding.storeVisit',
  //   conversionTitle: 'message.bizgainOnboarding.conversionStoreVisits',
  //   imageUrl: bizgainOnboardingImage.storeVisit
  // }
});

export const targetType = Object.freeze({
  latlng: 1,
  region: 2
});

export const radiuses = Object.freeze([
  {
    label: 'message.bizgainOnboarding.radius5kms',
    value: 5
  },
  {
    label: 'message.bizgainOnboarding.radius10km',
    value: 10
  },
  {
    label: 'message.bizgainOnboarding.radius15km',
    value: 15
  },
  {
    label: 'message.bizgainOnboarding.radius20km',
    value: 20
  },
  {
    label: 'message.bizgainOnboarding.radius25km',
    value: 25
  }
]);

export const distanceUnit = Object.freeze({
  miles: 1,
  kiloMeters: 2
})

export const locationTargetingType = Object.freeze({
  NEAR_BUSINESS: 1,
  SPECIFIC_AREA: 2
})

export const ageSliderLabel = Object.freeze([
  '18',
  '25',
  '35',
  '45',
  '55',
  '65',
  '65+'
]);

export const budgetType = Object.freeze({
  recommended: 1,
  custom: 2
})

export const defaultCampaignDuration = 30;

export const locationType = {
  country: 1
}

export const bizgainConfig = {
  appName: 'Bizgain',
  bizgainPrimaryLogo: `${AppConfig.staticImagesBasePath}bizgainOnboarding/bizgain-primary.png`,
  bizgainWhiteLogo: `${AppConfig.staticImagesBasePath}bizgainOnboarding/bizgain-white.png`,
  bizgainStripeLogo: `${AppConfig.staticImagesBasePath}bizgainOnboarding/bizgain-stripe.png`,
  profileSelectionIllustration: `${AppConfig.staticImagesBasePath}bizgainOnboarding/profile-selection.png`,
  inviteUserIllustration: `${AppConfig.staticImagesBasePath}bizgainOnboarding/setup-account.png`,
  tickPriceIllustration: `${AppConfig.staticImagesBasePath}bizgainOnboarding/tick-price.png`,
  campaignInfoImage: `${AppConfig.staticImagesBasePath}bizgainOnboarding/bizgain-campaign-info-image.png`,
  facebookIcon: `${AppConfig.staticImagesBasePath}bizgainOnboarding/fb.png`,
  googleMapsIcon: `${AppConfig.staticImagesBasePath}bizgainOnboarding/google.png`,
  websiteIcon: `${AppConfig.staticImagesBasePath}bizgainOnboarding/website.png`,
  freshChatIcon: `${AppConfig.staticImagesBasePath}bizgainOnboarding/chat-icon.png`,
  backButtonIcon: `${AppConfig.staticImagesBasePath}bizgainOnboarding/arrow-back-ios.svg`,
  backButtonDisabledIcon: `${AppConfig.staticImagesBasePath}bizgainOnboarding/arrow-back-ios-disabled.svg`,
  poweredByGoogleIcon: `${AppConfig.staticImagesBasePath}powered_by_google_on_white.jpg`,
  bizgainLogoHeight: 40,
  whatsappIcon: `${AppConfig.staticImagesBasePath}bizgainOnboarding/whatsapp.png`,
  instagramSqIcon: `${AppConfig.staticImagesBasePath}bizgainOnboarding/instagram-sq.png`,
  fbMessengerIcon: `${AppConfig.staticImagesBasePath}bizgainOnboarding/fb-messenger.png`,
  placeholderCreativeLogo: `${AppConfig.staticImagesBasePath}bizgainOnboarding/no_logo_creative_edit.png`,
  placeholderBusinessLogo: `${AppConfig.staticImagesBasePath}bizgainOnboarding/no_logo_page_dp.png`,
  arrowBackIcon: `${AppConfig.staticImagesBasePath}bizgainOnboarding/arrow_back.png`,
  arrowBackDisabledIcon: `${AppConfig.staticImagesBasePath}bizgainOnboarding/arrow_back_disabled.png`,
  previewUnavailable: `${AppConfig.staticImagesBasePath}bizgainOnboarding/preivew-unavailable.jpg`
}

export const recommendedLogoDimension = Object.freeze({
  height: 150,
  width: 150
});

export const assetTypes = {
  Facebook: 1,
  Google: 2
}

export const engines = Object.freeze({
  Google: 1,
  Facebook: 5,
  Twitter: 6
});

export const tickAnimationInterval = 2000;

export const benifits = Object.freeze({
  default:
  ['message.bizgainOnboarding.freeCreativesAndAdcopies', 'message.bizgainOnboarding.freeKeywordGeneration', 'message.bizgainOnboarding.customerSupport', 'message.bizgainOnboarding.consultation']
})

export const levyType = Object.freeze({
  EXTRACT_DISPOSABLE_BUDGET: 1,
  EXTRACT_SERVICE_FEE: 2,
  EXTRACT_TAX: 3,
  CALCULATE_DISPOSABLE_BUDGET_WITHOUT_SERVICE_FEE: 4,
  CALCULATE_DISPOSABLE_BUDGET: 5
});

// when adding a new launchState after budget, please update globalRouterGuard
export const launchState = Object.freeze({
  BUSINESSDETAILS: 100,
  BusinessDetailsV2: 110,
  BusinessDetailsSetupAnimationV2: 120,
  BUSINESSLOCATION: 200,
  BUSINESSPHONENUMBER: 201,
  BUSINESSTYPESERVICES: 300,
  BUSINESSDETAILSANIMATION: 301,
  GENDER: 400,
  OBJECTIVE: 500,
  PROMOTESERVICES: 800,
  OFFER: 900,
  CREATIVES: 1100,
  CreativeDetailsV2: 1101,
  CREATIVESPREVIEW: 1200,
  CREATIVESEDIT: 1201,
  FACEBOOKADPREVIEW: 1300,
  FACEBOOKADEDIT: 1301,
  GOOGLEADPREVIEW: 1400,
  GOOGLEADEDIT: 1401,
  SIGNUP: 1500,
  CREATIVEANIMATION: 1501,
  AGEGENDERTARGETING: 1600,
  LOCATIONTARGETING: 1700,
  BUDGET: 1800,
  ADACCOUNTSETUPANIMATION: 1810,
  CHANNELSELECTION: 1820,
  TARGETINGV2: 1825,
  FACEBOOKINTERESTS: 1840,
  GOOGLEKEYWORDS: 1850,
  LINKACCOUNTS: 1900,
  LAUNCHANIMATION: 1999,
  LAUNCHSUCCESSFUL: 2000
});

export const imageTypes = {
  logo: 1,
  lead: 2,
  creative: 3
};

export const imageLoadingStatus = {
  inDom: 1,
  inProgress: 2,
  finished: 3
};

export const cbApiUrlForTemplates = function(publishedRoimaticCreativeSetId, scaleFactor = 1){
  let urls = process.env.VUE_APP_CB_API_URL.split(',').map(url => url.trim());
  return `${urls[Math.floor(Math.random() * urls.length)]}t/${publishedRoimaticCreativeSetId}/?size=1000x1000&variant=Default&scaleFactor=${scaleFactor}&format=png&ptype=n`;
};

export const getImageSourceForCreative = async function(creativeUrl){
  return (process.env.VUE_APP_CAPACITOR_ENVIRONMENT === 'true') ? URL.createObjectURL(await getImageFileFromUrl(creativeUrl)) : creativeUrl;
};

export const businessDetailsMacros = {
  services: '{{businessDetail.services}} service',
  alternateServices: '{{businessDetail.services}}'
};

export const callToAction = {
  CALL_NOW: { text: 'CALL NOW' },
  GET_OFFER: { text: 'Get Offer' },
  LEARN_MORE: { text: 'Learn More' }
};

export const callToActions = Object.freeze({
  CALL_NOW: { label: 'Call Now', value: 1 },
  GET_OFFER: { label: 'Get Offer', value: 2 },
  LEARN_MORE: { label: 'Learn More', value: 3 },
  VISIT_WEBSITE: { label: 'Visit Website', value: 4 },
  VISIT_STORE: { label: 'Visit Store', value: 5 },
  BOOK_NOW: { label: 'Book Now', value: 6 },
  APPLY_NOW: { label: 'Apply Now', value: 7 },
  GET_QUOTE: { label: 'Get Quote', value: 8 },
  MESSAGE_PAGE: { label: 'Send Message', value: 9 }
});

export const supportedCtaForObjectives =  Object.freeze({
  [objectiveType.calls.id]: [
    callToActions.CALL_NOW
  ],
  [objectiveType.leadGeneration.id]: [
    callToActions.GET_OFFER,
    callToActions.LEARN_MORE,
    callToActions.BOOK_NOW,
    callToActions.APPLY_NOW,
    callToActions.GET_QUOTE
  ],
  [objectiveType.websiteVisits.id]: [
    callToActions.GET_OFFER,
    callToActions.LEARN_MORE,
    callToActions.VISIT_WEBSITE,
    callToActions.BOOK_NOW,
    callToActions.APPLY_NOW,
    callToActions.GET_QUOTE
  ],
  [objectiveType.instantMessages.id]: [
    callToActions.LEARN_MORE,
    callToActions.BOOK_NOW,
    callToActions.APPLY_NOW,
    callToActions.GET_QUOTE,
    callToActions.MESSAGE_PAGE
  ]
});

export const instantMessageDestinationApps = Object.freeze({
  MESSENGER: 1,
  INSTAGRAM_DIRECT: 2,
  WHATSAPP: 3
});

export const campaignStatus = Object.freeze({
  NEW: 1,
  IN_REVIEW: 2,
  LAUNCHED: 3,
  DELETED: 4
});

export const leadFormEnabledFields = Object.freeze({
  NAME: { label: 'Name', value: 1, privacyPolicyText: 'Full Name' },
  CONTACT_NUMBER: { label: 'Phone Number', value: 3, privacyPolicyText: 'Phone number' },
  EMAIL: { label: 'Email', value: 2, privacyPolicyText: 'Email address' },
  SERVICE_NEEDED: { label: 'Service needed', value: 4, privacyPolicyText: 'Any other data such as personal preferences, requirements, or comments' },
  CITY: { label: 'City', value: 5, privacyPolicyText: 'Location details such as your address, city, or country' }
});

export const leadFormEnabledFieldsForXs = Object.freeze({
  NAME: { label: 'Name', value: 1, privacyPolicyText: 'Full Name' },
  CITY: { label: 'City', value: 5, privacyPolicyText: 'Location details such as your address, city, or country' },
  CONTACT_NUMBER: { label: 'Phone Number', value: 3, privacyPolicyText: 'Phone number' },
  SERVICE_NEEDED: { label: 'Service needed', value: 4, privacyPolicyText: 'Any other data such as personal preferences, requirements, or comments' },
  EMAIL: { label: 'Email', value: 2, privacyPolicyText: 'Email address' }
});

export const leadFormFieldsByValue = Object.freeze({
  1: 'NAME',
  2: 'EMAIL',
  3: 'CONTACT_NUMBER',
  4: 'SERVICE_NEEDED',
  5: 'CITY'
});

export const privacyPolicyDataAccessTypes = Object.freeze({
  CONTACT_REGARDING_SERVICES: { label: 'Contact regarding the services', value: 1 },
  SEND_NEWSLETTER: { label: 'Send Newsletter', value: 2 },
  SEND_PROMOTIONAL_MESSAGES: { label: 'Send promotional mail or messages', value: 3 },
  RETARGET_FOR_CAMPAIGNS: { label: 'Retarget for advertising campaigns', value: 4 }
});

export const leadForms = Object.freeze({
  LEAD_FORM: 1,
  COMPLETION_FORM: 2
});

export const editCampaignTabs = Object.freeze({
  // commenting General to hide it from UI
  // GENERAL: { id: 0, label: 'message.bizgainOnboarding.general' },
  CREATIVE_AND_ADS: { id: 1, label: 'message.bizgainOnboarding.creativeAds' }
  // TARGETING: { id: 2, label: 'message.bizgainOnboarding.targeting' }
});

export const facebookAdDetailsOptions = Object.freeze({
  EDIT_CREATIVE: { id: 1, label: 'message.bizgainOnboarding.editCreative' },
  EDIT_AD_COPY: { id: 2, label: 'message.bizgainOnboarding.editAdCopy'  }
});

export const businessImageType = {
  Default: 0,
  StockImage: 1,
  Website: 2,
  GoogleMyBusiness: 3,
  Facebook: 4,
  CustomUpload: 5
};

export const requestPool = Object.freeze({
  status: {
    NEW: 0,
    IN_PROGRESS: 1,
    DONE: 2,
    FAILED: 3
  },
  intervalTimer: 3000,
  timeoutTimer: 300000
});

export const suggestedBusinessImageCount = 4;

export const DurationTypes = Object.freeze({
  LIFETIME: 2,
  DAILY: 1
})

export const SchedulingModes = {
  RunContinuously: 1,
  Schedule: 2
}

export const fallbackBudgetDetails = {
  'INR': {
    minimumBudget: 350.0,
    recommendedBudget: 350.0,
    serviceFee: 0,
    tax: 0.18
  },
  'GBP': {
    minimumBudget: 20.0,
    recommendedBudget: 30.0,
    serviceFee: 0.20,
    tax: 0.0
  }
}

export const sortType = {
  ascending: 1,
  descending: 2
}

export const leadFormDescription = Object.freeze({
  WITH_OFFER: { value: 'Fill out the form to claim the offer' },
  SKIP_OFFER: { value: 'Fill the form to know more'  }
});

export const fallbackCountryCode = 'IN';

// might have to handle it based on country code
export const privacyPolicyLink = 'https://bizgain.com/privacy';
export const termsOfServiceLink = 'https://bizgain.com/terms';

export const engineDetails = Object.freeze({
  google:
  {
    id: 1,
    title: 'message.bizgainOnboarding.google',
    imageUrl: bizgainOnboardingImage.google
  },
  fb:
  {
    id: 2,
    title: 'message.bizgainOnboarding.facebook',
    imageUrl: bizgainOnboardingImage.fb
  },
  instagram:
  {
    id: 3,
    title: 'message.bizgainOnboarding.instagram',
    imageUrl: bizgainOnboardingImage.ig
  }
});

export const onboardingSections = Object.freeze({
  BUSINESSDETAILS: 1,
  CREATIVE: 2,
  LAUNCH: 3,
  signup: 4
});

export const signupFlowSteps = [{
  section: onboardingSections.BUSINESSDETAILS,
  steps: [{
    route: ['businessDetails']
  },
  {
    route: ['businessLocationDetails']
  },
  {
    route: ['businessPhoneNumber']
  },
  {
    route: ['businessTypeServices']
  }]
},
{
  section: onboardingSections.CREATIVE,
  steps: [{
    route: ['selectObjective', 'promoteServices', 'offerDetails']
  },
  {
    route: ['imageCreatives', 'imageCreativesCreativePreview', 'imageCreativesCreativeEdit']
  },
  {
    route: ['imageCreativesAdPreview', 'imageCreativesAdDetailsEdit']
  },
  {
    route: ['googleAds', 'googleAdsEdit']
  },
  {
    route: ['emailSignup']
  }]
},
{
  section: onboardingSections.LAUNCH,
  steps: [{
    route: ['ageGenderTarget']
  },
  {
    route: ['locationTargeting']
  },
  {
    route: ['budget']
  }]
},
{
  section: onboardingSections.signup,
  steps: [{
    route: ['businessDetailsv2', 'businessDetailsSetupAnimationV2']
  },
  {
    route: ['creativedetailsv2', 'imageCreativesAdDetailsEdit', 'googleAdsEdit', 'imageCreativesCreativeEdit']
  },
  {
    route: ['businessPhoneNumber', 'emailSignup', 'budget']
  }]
}]

export const subsequentFlowSteps = [
  {
    section: onboardingSections.BUSINESSDETAILS,
    steps: []
  },
  {
    section: onboardingSections.CREATIVE,
    steps: [{
      route: ['subSequentSelectObjective', 'subSequentPromoteServices', 'subSequentOfferDetails', 'subSequentGoogleAdsEdit']
    },
    {
      route: ['subSequentImageCreatives', 'subSequentImageCreativesCreativePreview', 'subSequentImageCreativesCreativeEdit']
    },
    {
      route: ['subSequentImageCreativesAdPreview', 'subSequentImageCreativesAdDetailsEdit']
    },
    {
      route: ['subSequentgoogleAds', 'subSequentgoogleAdsEdit']
    }]
  },
  {
    section: onboardingSections.LAUNCH,
    steps: [{
      route: ['subSequentageGenderTarget']
    },
    {
      route: ['subSequentlocationTargeting']
    },
    {
      route: ['budget']
    },
    {
      route: ['linkAccounts']
    }]
  },
  {
    section: onboardingSections.signup,
    steps: [{
      route: ['subsequentbusinessDetailsv2', 'subsequentbusinessDetailsSetupAnimationV2']
    },
    {
      route: ['subsequentcreativedetailsv2', 'subSequentImageCreativesCreativeEdit', 'subSequentgoogleAdsEdit', 'subSequentImageCreativesAdDetailsEdit']
    },
    {
      route: ['subsequentbudget']
    }]
  }]

export const adAccountSetupAnimationPath = Object.freeze({
  advertisingProfile: 'assets/animation/AdAccountSetup/advertisingprofile.json',
  personalizedAds: 'assets/animation/AdAccountSetup/personalizedads.json',
  campaignAudience: 'assets/animation/AdAccountSetup/campaignaudience.json'
});

export const gstCheckInApiErrorCode = {
  creditExhausted: 'CREDIT_NOT_AVAILABLE',
  gstNumberNotFound: 'GSTNUMBER_NOT_FOUND'
}

export const OTPChannelTypes = Object.freeze({
  EMAIL: 1,
  SMS: 2,
  WHATSAPP: 3
});

export const dataPackagesTypes = Object.freeze({
  Starter: 1,
  Growth: 2,
  Custom: 3
})
export const budgetDashboardDescription = ['message.onboarding.description1', 'message.onboarding.description2', 'message.onboarding.description3', 'message.onboarding.description4', 'message.onboarding.description5']

export const phoneNoOptions = Object.freeze({
  required: 1,
  optional: 2,
  Disabled: 3
});
